/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddCompaniesRequest
 */
export interface AddCompaniesRequest {
  /**
   *
   * @type {string}
   * @memberof AddCompaniesRequest
   */
  companyListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AddCompaniesRequest
   */
  companyIds: Array<string>;
}

/**
 * Check if a given object implements the AddCompaniesRequest interface.
 */
export function instanceOfAddCompaniesRequest(
  value: object,
): value is AddCompaniesRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  return true;
}

export function AddCompaniesRequestFromJSON(json: any): AddCompaniesRequest {
  return AddCompaniesRequestFromJSONTyped(json, false);
}

export function AddCompaniesRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCompaniesRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    companyIds: json["companyIds"],
  };
}

export function AddCompaniesRequestToJSON(json: any): AddCompaniesRequest {
  return AddCompaniesRequestToJSONTyped(json, false);
}

export function AddCompaniesRequestToJSONTyped(
  value?: AddCompaniesRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    companyIds: value["companyIds"],
  };
}
